import { render } from "./BlockingPage.vue?vue&type=template&id=7601dad4&scoped=true"
const script = {}

import "./BlockingPage.vue?vue&type=style&index=0&id=7601dad4&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7601dad4"]])

export default __exports__